import { Injectable } from '@angular/core';
import { BehaviorSubject, take } from 'rxjs';
import { Section } from '../models/section';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SectionService {
  public constructor(private httpClient: HttpClient) { }

  private readonly apiUrl = '/api/Section/';

  private sectionSubject = new BehaviorSubject<Section[]| null>(null);
  sections$ = this.sectionSubject.asObservable();

  private initiatorSectionSubject = new BehaviorSubject<Section | null>(null);
  initiatorSection$ = this.initiatorSectionSubject.asObservable();

  getSections(projectId: string): void {
    this.httpClient.get<Section[]>(this.apiUrl + projectId + '/get').pipe(take(1)).subscribe({
      next: (result) => this.sectionSubject.next(result),
      error: (err) => console.error('Ошибка загрузки секций', err),
    });
  }

  addSection(section: Section): void {
    this.httpClient.post<Section>(this.apiUrl + 'create', section).subscribe()
  }

  deleteSection(id: string, projectId: string): void {
    this.httpClient.delete(this.apiUrl + id + '/delete').subscribe()
  }

  reset() {
    this.sectionSubject.next(null);
  }

  addLocal(section: Section, isInitiator: boolean): void {
    const sections = this.sectionSubject.value;
    if (!sections) return;

    this.sectionSubject.next([...sections, section].sort((a, b) => a.name.localeCompare(b.name)));

    if (isInitiator) {
      this.initiatorSectionSubject.next(section);
    }
  }

  updateLocal(section: Section): void {
    const sections = this.sectionSubject.value;
    if (!sections) return;

    this.sectionSubject.next(
      sections.map(s => s.id === section.id ? section : s).sort((a, b) => a.name.localeCompare(b.name)));

  }

  removeLocal(sectionId: string): void {
    const sections = this.sectionSubject.value;
    if (!sections) return;

    this.sectionSubject.next(
      sections.filter(s => s.id !== sectionId).sort((a, b) => a.name.localeCompare(b.name)));
  }
}
